export const MenuIdCustomerExperiences = 'CUSTOMER_EXPERIENCES' as const;
